import {
  Landmark,
  Building2,
  Receipt,
  Coins,
  Percent,
  Gauge,
  ShieldCheck,
} from "lucide-react";
import PageHero from "../../components/shared/PageHero";
import CtaBand from "../../components/shared/CtaBand";
import "./BondsPage.css";

const BOND_TYPES = [
  {
    icon: Landmark,
    title: "Government Bonds",
    desc: "Sovereign-backed securities for capital protection and steady income — suitable for conservative allocations and goal buffers.",
  },
  {
    icon: Building2,
    title: "Corporate Bonds",
    desc: "Higher yields from rated issuers. We help assess credit quality, tenure, and liquidity before you lock in.",
  },
  {
    icon: Receipt,
    title: "Tax-Free Bonds",
    desc: "Interest that may be exempt from income tax for eligible issues — useful for high-bracket investors seeking efficient income.",
  },
  {
    icon: Coins,
    title: "Sovereign Gold Bonds (SGB)",
    desc: "Gold exposure with periodic interest and potential capital gains on maturity — a disciplined alternative to physical gold.",
  },
];

const EXTRAS = [
  {
    icon: Percent,
    title: "YTM Explanation",
    desc: "Yield to Maturity shows the annualised return if you hold to maturity — accounting for price, coupon, and time. We explain YTM in plain language before you invest.",
  },
  {
    icon: Gauge,
    title: "Risk Rating",
    desc: "Credit ratings, tenure risk, and interest-rate sensitivity are reviewed so you understand downside — not just coupon rates.",
  },
  {
    icon: ShieldCheck,
    title: "Bond Benefits",
    desc: "Predictable cash flows, portfolio diversification, and lower volatility versus equity — a core building block for balanced wealth plans.",
  },
];

export default function BondsPage() {
  return (
    <div className="bonds-page">
      <PageHero
        badge="Bonds"
        title="Fixed-income clarity for your portfolio"
        subtitle="Government, corporate, tax-free bonds and SGBs — with clear YTM guidance and risk ratings before you invest."
        actions={[
          { label: "Book Free Consultation", to: "/contact", primary: true },
          { label: "Review My Portfolio", to: "/portfolio-review" },
        ]}
      />

      <section className="pm-section bonds-types">
        <div className="pm-container">
          <span className="pm-badge">
            <span className="pm-badge-dot" />
            Bond Universe
          </span>
          <h2 className="pm-section-title">Instruments we guide you through</h2>
          <div className="bonds-grid">
            {BOND_TYPES.map((b) => {
              const Icon = b.icon;
              return (
                <article key={b.title} className="pm-card bonds-card">
                  <div className="bonds-card__icon">
                    <Icon size={22} />
                  </div>
                  <h3>{b.title}</h3>
                  <p>{b.desc}</p>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <section className="pm-section bonds-extras">
        <div className="pm-container">
          <span className="pm-badge">
            <span className="pm-badge-dot" />
            Decision Support
          </span>
          <h2 className="pm-section-title">Understand before you invest</h2>
          <div className="bonds-extras-grid">
            {EXTRAS.map((e) => {
              const Icon = e.icon;
              return (
                <article key={e.title} className="pm-card bonds-card">
                  <div className="bonds-card__icon">
                    <Icon size={22} />
                  </div>
                  <h3>{e.title}</h3>
                  <p>{e.desc}</p>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <CtaBand
        title="Looking for stable income in your portfolio?"
        subtitle="Talk to us about bond allocation that fits your goals and tax situation."
        primary={{ label: "Book Free Consultation", to: "/contact" }}
        secondary={{ label: "Talk to an Expert", to: "/contact" }}
      />
    </div>
  );
}
